import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-calculate',
  standalone: true,
  templateUrl: '../../assets/calculate.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCalculateIcon {}
